import { gql } from '@apollo/client'

export const GET_ADDRESS = gql`
  query GetAddress {
    user {
      uuid
      email
      isAddressValid
      address {
        line1
        line2
        city
        state
        zip
        country
      }
      wallet {
        fiatRunningTotal
      }
    }
  }
`

export const CUSTOMER_PAYMENT_METHODS = gql`
  query CUSTOMER_PAYMENT_METHODS {
    customerPaymentMethods {
      defaultPaymentMethodId
      paymentMethods {
        id
        created
        brand
        expYear
        last4
      }
    }
  }
`

export const GET_ORDER_STATUS = gql`
  query Order($orderId: ID!) {
    order(id: $orderId) {
      status
    }
  }
`

export const GET_ORDER_DETAILS = gql`
  query OrderDetails($orderId: ID!) {
    order(id: $orderId) {
      status
      id
      pricePaid
      lineItems {
        id
        price
        productType
        distributedType
        productId
        project {
          name
        }
        distributedItem {
          ... on Nifty {
            id
            frame {
              id
              uri
              smpteTimecode
              moment {
                id
                type
                projectSlug
                title
                reactionCount
                totalFrames
                episode {
                  id
                  episodeNumber
                  season {
                    seasonNumber
                  }
                  show {
                    id
                    name
                    type
                  }
                }
              }
            }
            gift {
              id
              createdAt
              toFirstName
              toLastName
              message
            }
            signatures {
              id
              signatureUrl
              signedBy {
                lastName
                firstName
              }
            }
          }
          ... on Signature {
            id
            signedBy {
              firstName
              lastName
            }
            signatureUrl
          }
        }
      }
      shippingAddress {
        line1
        line2
        city
        state
        zip
        country
      }
    }
    user {
      id
      wallet {
        id
        niftyList(sort: "desc") {
          count
          niftys {
            id
            claimedStatus {
              id
              claimedAt
              reasonEarned
              providedAt
              claimToken
            }
            frame {
              id
            }
          }
        }
      }
    }
  }
`

export const GET_COLLECTIBLE_ORDER_HISTORY = gql`
  query getCollectibleOrderHistory {
    getAllCollectibleOrdersForUser {
      id
      pricePaid
      lineItems {
        projectId
        productType
        price
        shippingMethod
        status
        shipments {
          carrierName
          carrierService
          trackingNumber
          trackingUrl
        }
      }
    }
  }
`

export const GET_COLLECTIBLE_DOWNLOAD_BY_FRAME_ID = gql`
  query GET_COLLECTIBLE_DOWNLOAD_BY_FRAME_ID($frameId: ID!) {
    keepsakeGenerateDownload(frameId: $frameId) {
      url
    }
  }
`

export const GET_USER_COLLECTIBLES = gql`
  query getUserCollectibles {
    user {
      id
      wallet {
        niftyList(sort: "desc") {
          count
          niftys {
            id
            totalViews
            createdAt
            claimedStatus {
              id
              claimedAt
              reasonEarned
              providedAt
              claimToken
            }
            contract {
              id
              type
              projectId
              type
            }
            images {
              id
              url
              collectionName
              projectId
              type
              name
              rarity
              meta {
                description
                name
                edition
                attributes {
                  trait_type
                  value
                }
              }
            }
            frames {
              id
              smpteTimecode
              uri(resolution: mid_res)
              episode {
                id
                name
                description
                episodeNumber
                canonId
                show {
                  id
                  name
                  projectId
                }
                season {
                  seasonNumber
                }
              }
              moment {
                id
                title
                description
                thumbnail
                type
                reactionCount
                uri
                projectSlug
                episode {
                  id
                  guid
                  episodeNumber
                  season {
                    seasonNumber
                  }
                  show {
                    id
                    name
                    type
                  }
                }
              }
            }
            signatures {
              id
              signatureUrl
              cloudinaryPath
              createdAt
              signedBy {
                id
                uuid
                screenName
              }
            }
            gift {
              id
              createdAt
              message
              toFirstName
              toLastName
              gifter {
                uuid
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  }
`

export const CLAIM_COLLECTIBLE_FRAMES_MUTATION = gql`
  mutation claimCollectibleFrames {
    claimCollectibleFrames {
      code
    }
  }
`
export const CLAIM_COLLECTIBLE_FRAME_MUTATION = gql`
  mutation claimCollectibleFrame($input: ClaimCollectibleFrameInput!) {
    claimCollectibleFrame(input: $input) {
      code
    }
  }
`
